import { fsmTenant } from "./fsm";
import { ilParrocchialeTenant } from "./il_parrocchiale";
import { TenantConfig } from "./types";

const tenantMap: Record<TenantConfig["id"], TenantConfig> = {
  fsm: fsmTenant,
  il_parrocchiale: ilParrocchialeTenant,
};

export const currentTenantId = (process.env.REACT_APP_TENANT ||
  "fsm") as TenantConfig["id"];

export const currentTenant = tenantMap[currentTenantId] || fsmTenant;
